import * as bootstrap from 'bootstrap';
import jsKit from './jsKit';
import basketPlugins from './basketPlugins';

const focusDiscountCouponInput = () => {
  const input = document.getElementById('discount_coupon_code_text');
  if (input) {
    input.focus();
  }
};

const setDiscountCouponPanelHtml = (html) => {
  const panel = document.getElementById('discount-panel');
  if (panel && typeof html !== 'undefined') {
    panel.innerHTML = html;
  }
};

const getBasketDiscountCouponFormData = () => {
  const formData = new FormData();
  const input = document.getElementById('discount_coupon_code_text');

  if (input) {
    formData.set('basket_discount_coupon_form[code]', input.value);
  }

  return formData;
};

const initBasketProductOptionPopovers = () => {
  const productsList = document.getElementById('products-list');
  if (!productsList) {
    return;
  }

  productsList.querySelectorAll('[data-bs-toggle="popover"][data-content-id]').forEach((trigger) => {
    const content = document.getElementById(trigger.dataset.contentId)?.innerHTML;
    if (typeof content !== 'undefined') {
      bootstrap.Popover.getOrCreateInstance(trigger, { content, html: true });
    }
  });

  jsKit.initTooltipsIn(productsList);
};

const appendProductsToOrder = async (e) => {
  e.preventDefault();

  const trigger = e.delegateTarget || e.currentTarget;
  const orderId = trigger.dataset.jsAppendProductsToOrder;
  if (!orderId || !window.confirm('Na pewno dodać zawartość koszyka do istniejącego już zamówienia?')) {
    return;
  }

  const formData = new FormData();
  formData.set('order_action_form[order_id]', orderId);

  jsKit.setLoading(trigger, true, { disabled: true });
  const response = await jsKit.requestUrl('/basket/appendProductsToOrder/', 'json', 'POST', formData);
  jsKit.setLoading(trigger, false, { disabled: true });

  if (response?.validated && response.location) {
    window.location = response.location;
    return;
  }

  jsKit.showNotificationsPanel(response?.error_message || 'Nie udało się dodać produktów do zamówienia.');
};

const reloadBasketContentStep1 = async () => {
  const response = await jsKit.requestUrl('/basket/loadBasketContentStep1');
  if (!response) {
    return;
  }

  Object.entries(response).forEach(([id, html]) => {
    jsKit.setHtml(`#${id}`, html);
  });

  initBasketProductOptionPopovers();

  document.getElementById('basket_loader')?.style.setProperty('display', 'none');

  const collapse = document.getElementById('collapseGratisPanel');
  if (collapse) {
    bootstrap.Collapse.getOrCreateInstance(collapse, { toggle: false }).hide();
  }
};

const removeProduct = async (e) => {
  e.preventDefault();

  const trigger = e.delegateTarget || e.currentTarget;
  const productId = trigger.dataset.jsRemoveProduct;
  if (!productId || !window.confirm(trigger.dataset.jsRemoveProductConfirm)) {
    return;
  }

  document.getElementById('basket_loader')?.style.setProperty('display', 'block');
  jsKit.setLoading(trigger, true, { disabled: true });
  const formData = new FormData();
  formData.set('remove_product[product_unique]', productId);

  const response = await jsKit.requestUrl('/basket/removeProduct/', 'json', 'POST', formData);
  jsKit.setLoading(trigger, false, { disabled: true });

  if (!response?.validated) {
    jsKit.showErrors(response, 'body');
    document.getElementById('basket_loader')?.style.setProperty('display', 'none');
    return;
  }

  if (response.empty_basket) {
    document.location = '/';
    return;
  }

  if (response.is_removed) {
    if (trigger.dataset.jsRemoveProductReload === '1') {
      window.location.reload();
      return;
    }

    reloadBasketContentStep1();
  }
};

const changeProductAmount = async (e) => {
  const trigger = e.delegateTarget || e.currentTarget;
  const productId = trigger.dataset.jsChangeProductAmountProduct;
  const change = Number(trigger.dataset.jsChangeProductAmountChange || 0);
  const input = document.getElementById(`product-${productId}-amount`);

  if (!productId || !input) {
    return;
  }

  const currentAmount = Number.parseInt(input.value, 10);
  const amount = Number.isNaN(currentAmount) ? 1 : Math.max(0, currentAmount + change);
  input.value = amount;

  const formData = new FormData();
  formData.set('change_product_amount[product_unique]', productId);
  formData.set('change_product_amount[amount]', amount);

  jsKit.setLoading(trigger, true, { disabled: true });
  const response = await jsKit.requestUrl('/basket/changeProductAmount', 'json', 'POST', formData);
  jsKit.setLoading(trigger, false, { disabled: true });

  if (response?.validated) {
    reloadBasketContentStep1();
  } else {
    jsKit.showErrors(response, 'body');
  }

  if (response?.load_flash_message) {
    jsKit.loadFlashMessages(response.load_flash_message);
  }
};

const removeDiscountCoupon = async (e) => {
  e.preventDefault();

  const trigger = e.delegateTarget || e.currentTarget;
  const coupon = trigger.dataset.jsRemoveDiscountCoupon;
  if (!coupon) {
    return;
  }

  jsKit.setLoading(trigger, true, { disabled: true });
  const response = await jsKit.requestUrl(`/basket/removeDiscountCoupon/${coupon}`);
  jsKit.setLoading(trigger, false, { disabled: true });

  if (!response) {
    return;
  }

  Object.entries(response).forEach(([id, html]) => {
    jsKit.setHtml(`#${id}`, html);
  });
};

const changeProductOption = async (e) => {
  const trigger = e.delegateTarget || e.currentTarget;
  const productId = trigger.dataset.jsChangeProductOptionProduct;
  const option = trigger.dataset.jsChangeProductOption;
  if (!productId || !option) {
    return;
  }

  const formData = new FormData();
  formData.set('change_product_option[product_unique]', productId);
  formData.set('change_product_option[option]', option);

  jsKit.setLoading(trigger, true, { disabled: true });
  const response = await jsKit.requestUrl('/basket/changeProductOption', 'json', 'POST', formData);
  jsKit.setLoading(trigger, false, { disabled: true });

  if (response?.validated) {
    reloadBasketContentStep1();
  } else {
    jsKit.showErrors(response, 'body');
  }
};

const reloadBasketContentStep2 = async () => {
  const response = await jsKit.requestUrl('/basket/loadBasketContentStep2');
  if (!response) {
    return;
  }

  Object.entries(response).forEach(([id, html]) => {
    jsKit.setHtml(`#${id}`, html);
  });
};

const updateBasketDeliveryAndPayment = async (nextStepUrl) => {
  const form = document.getElementById('basket_delivery_payment_form');
  if (!form) {
    return;
  }

  const formData = new FormData(form);
  const inputs = form.querySelectorAll('#payment-options input, #delivery-options input');
  inputs.forEach((input) => { input.disabled = true; });

  const response = await jsKit.requestUrl(
    `/basket/updateDeliveryAndPayment/${nextStepUrl === false ? '' : '1'}`,
    'json',
    'POST',
    formData,
  );
  inputs.forEach((input) => { input.disabled = false; });

  if (response?.validated) {
    if (nextStepUrl !== false) {
      document.location = nextStepUrl;
      return;
    }

    reloadBasketContentStep2();
  } else if (nextStepUrl !== false) {
    jsKit.showErrors(response, '#basket_delivery_payment_form');
  }
};

const setBasketAddress = async (e, type) => {
  const trigger = e.delegateTarget || e.currentTarget;
  const formName = type === 'delivery' ? 'basket_delivery_address' : 'basket_invoice_address';
  const formData = new FormData();
  formData.set(`${formName}[address_id]`, trigger.value);

  jsKit.setLoading(trigger, true, { disabled: true });
  const response = await jsKit.requestUrl(`/basket/set${type === 'delivery' ? 'Delivery' : 'Invoice'}Address/`, 'json', 'POST', formData);
  jsKit.setLoading(trigger, false, { disabled: true });

  if (!response?.validated) {
    jsKit.showErrors(response, '#basket_delivery_payment_form');
    return;
  }

  jsKit.setHtml(type === 'delivery' ? '#delivery-data' : '#invoice-data', response.content);
  if (type === 'delivery') {
    document.getElementById('delivery_country_id')?.dispatchEvent(new Event('change', { bubbles: true }));
  }
};

const setDeliveryAddress = (e) => setBasketAddress(e, 'delivery');
const setInvoiceAddress = (e) => setBasketAddress(e, 'invoice');

const toggleElement = (selector, visible) => {
  const element = document.querySelector(selector);
  if (element) {
    element.style.display = visible ? '' : 'none';
  }
};

const togglePaymentOperators = () => toggleElement('#payments_list', true);
const toggleInvoiceData = (e) => {
  const visible = (e.delegateTarget || e.currentTarget).checked;
  toggleElement('#invoice-data', visible);
  toggleElement('#invoice_address_select', visible);
};
const toggleRemarks = (e) => toggleElement('#order_comments', (e.delegateTarget || e.currentTarget).checked);
const toggleDeliveryRemarks = (e) => toggleElement('#delivery_comments', (e.delegateTarget || e.currentTarget).checked);

const loadBasketComment = async (type, editMode, trigger = null) => {
  if (trigger) {
    jsKit.setLoading(trigger, true, { disabled: true });
  }
  const html = await jsKit.requestUrl(`/basket/load${type === 'client' ? 'Client' : 'Delivery'}Comment/${editMode}`, 'text');
  if (trigger) {
    jsKit.setLoading(trigger, false, { disabled: true });
  }
  jsKit.setHtml(type === 'client' ? '#client-comment' : '#delivery-comment', html);
};

const loadClientComment = (e) => {
  e.preventDefault();
  const trigger = e.delegateTarget || e.currentTarget;
  return loadBasketComment('client', trigger.dataset.jsLoadClientComment, trigger);
};
const loadDeliveryComment = (e) => {
  e.preventDefault();
  const trigger = e.delegateTarget || e.currentTarget;
  return loadBasketComment('delivery', trigger.dataset.jsLoadDeliveryComment, trigger);
};

const saveBasketComment = async (e, type) => {
  e.preventDefault();

  const trigger = e.delegateTarget || e.currentTarget;
  const formName = type === 'client' ? 'basket_client_comment_form' : 'basket_delivery_comment_form';
  const input = document.getElementById(type === 'client' ? 'client_comment' : 'delivery_comment');
  if (!input) {
    return;
  }

  const formData = new FormData();
  formData.set(`${formName}[comment]`, input.value);

  jsKit.setLoading(trigger, true, { disabled: true });
  const response = await jsKit.requestUrl(`/basket/save${type === 'client' ? 'Client' : 'Delivery'}Comment/`, 'json', 'POST', formData);
  jsKit.setLoading(trigger, false, { disabled: true });

  if (response?.validated) {
    await loadBasketComment(type, '0');
  } else {
    jsKit.showErrors(response, 'body');
  }
};

const saveClientComment = (e) => saveBasketComment(e, 'client');
const saveDeliveryComment = (e) => saveBasketComment(e, 'delivery');

const setContestAgreement = async (e) => {
  const trigger = e.delegateTarget || e.currentTarget;
  const formData = new FormData();
  formData.set('basket_contest_agreement[contest]', trigger.value);
  formData.set('basket_contest_agreement[status]', trigger.checked ? '1' : '0');

  const response = await jsKit.requestUrl('/basket/setContestAgreement', 'json', 'POST', formData);
  if (!response?.validated) {
    jsKit.showErrors(response, 'body');
  }
};

const changeGratis = (e) => {
  e.preventDefault();
  toggleElement('#basket-extras-2', true);
  toggleElement('#basket-extras-1', false);
  toggleElement('#basket-products-gratis', true);
};

const setUnfoldPackages = async (e) => {
  const trigger = e.delegateTarget || e.currentTarget;
  const unfold = trigger.checked ? 1 : 0;

  jsKit.setLoading(trigger, true, { disabled: true });
  const response = await jsKit.requestUrl(`/basket/setUnfoldPackages/${unfold}`);
  jsKit.setLoading(trigger, false, { disabled: true });

  if (response?.validated) {
    await basketPlugins.reloadDeliveryOptions();
  } else {
    jsKit.showErrors(response, 'body');
  }
};

const checkOrderToMergeId = async () => {
  const orderToMergeId = document.getElementById('order_to_merge_id')?.value;
  if (!orderToMergeId) {
    return;
  }

  const html = await jsKit.requestUrl(`/basket/setOrderToMerge/${encodeURIComponent(orderToMergeId)}`, 'text');
  if (html) {
    jsKit.setHtml('#delivery-comment', html);
  }
};

const createOrder = async (e) => {
  e.preventDefault();

  const trigger = e.delegateTarget || e.currentTarget;
  jsKit.setLoading(trigger, true, { disabled: true });
  await checkOrderToMergeId();

  const response = await jsKit.requestUrl('/basket/createOrder', 'json', 'POST', {});
  if (response?.validated) {
    trigger.remove();
    document.getElementById('basket-step-btn-done')?.style.setProperty('display', 'inline-flex');
    document.location = response.location;
    return;
  }

  jsKit.setLoading(trigger, false, { disabled: true });
  jsKit.showErrors(response, 'body');
  if (response?.load_flash_message) {
    jsKit.loadFlashMessages(response.load_flash_message);
  }
};

const updateBasketBaseData = async (nextStepUrl) => {
  const form = document.getElementById('basket_form');
  if (!form) {
    return;
  }

  const response = await jsKit.requestUrl(
    `/basket/updateBaseData/${nextStepUrl === false ? '' : '1'}`,
    'json',
    'POST',
    new FormData(form),
  );

  if (!response) {
    return;
  }

  if (response.validated) {
    if (nextStepUrl !== false) {
      document.location = nextStepUrl;
      return;
    }

    reloadBasketContentStep1();
    return;
  }

  if (nextStepUrl !== false) {
    jsKit.showErrors(response, '#basket_form');
  }

  if (response.amount_validation_errors_count) {
    reloadBasketContentStep1();
  }

  if (response.load_flash_message) {
    jsKit.loadFlashMessages(response.load_flash_message);
  }
};

const basketPaymentAndDelivery = async (e) => {
  e.preventDefault();

  const trigger = e.delegateTarget || e.currentTarget;
  jsKit.setLoading(trigger, true, { disabled: true });
  if (trigger.dataset.jsBasketPaymentAndDeliveryNextStep === 'summary') {
    await updateBasketDeliveryAndPayment(window.basket_url_summary);
  } else {
    await updateBasketBaseData(window.basket_url_payment_delivery);
  }
  jsKit.setLoading(trigger, false, { disabled: true });
};

const omitRegistration = async (e) => {
  e.preventDefault();

  const trigger = e.delegateTarget || e.currentTarget;
  const registrationSection = document.getElementById('registration_section');

  jsKit.setLoading(trigger, true);
  jsKit.setLoading(registrationSection, true);

  const response = await jsKit.requestUrl('/basket/omitRegistration', 'json', 'POST', new FormData());

  jsKit.setLoading(trigger, false);
  jsKit.setLoading(registrationSection, false);

  if (response?.url) {
    document.location = response.url;
  }
};

const basketClientLogin = async (e) => {
  e.preventDefault();

  const form = e.delegateTarget || e.currentTarget;

  jsKit.setLoading(form, true);
  const response = await jsKit.requestUrl('/client/login', 'json', 'POST', new FormData(form));
  jsKit.setLoading(form, false);

  if (!response) {
    return;
  }

  if (response.validated) {
    document.location = response.location;
    return;
  }

  jsKit.showErrors(response, '#basket_login_form');
};

const basketClientRegister = async (e) => {
  e.preventDefault();

  const form = e.delegateTarget || e.currentTarget;
  const submitButton = document.getElementById('btn-basket-register');

  jsKit.setLoading(form, true);
  jsKit.setLoading(submitButton, true);

  const response = await jsKit.requestUrl('/client/register', 'json', 'POST', new FormData(form));

  jsKit.setLoading(form, false);
  jsKit.setLoading(submitButton, false);

  if (!response) {
    return;
  }

  if (response.validated) {
    document.location = response.location;
    return;
  }

  jsKit.showErrors(response, '#register_form');
};

const checkDiscountCoupon = async (e) => {
  e.preventDefault();

  const button = e.delegateTarget || e.currentTarget;
  const input = document.getElementById('discount_coupon_code_text');
  if (!input || input.value.trim() === '') {
    input?.focus();
    return;
  }

  jsKit.setLoading(button, true);
  const response = await jsKit.requestUrl('/basket/checkDiscountCoupon/', 'json', 'POST', getBasketDiscountCouponFormData());
  jsKit.setLoading(button, false);

  if (!response) {
    return;
  }

  if (response.validated) {
    Object.entries(response.sections || {}).forEach(([selector, html]) => {
      const element = document.getElementById(selector);
      if (element) {
        element.innerHTML = html;
      }
    });
    return;
  }

  jsKit.showNotificationsPanel(response.error_message, 'error');
};

const closeDiscountCouponPanel = async (e) => {
  e.preventDefault();

  const response = await jsKit.requestUrl('/basket/closeDiscountCouponPanel/', 'text');
  if (typeof response !== 'undefined') {
    setDiscountCouponPanelHtml(response);
  }
};

const loadDiscountCouponPanel = async (e) => {
  e.preventDefault();

  const button = e.delegateTarget || e.currentTarget;
  const status = button?.dataset.jsLoadDiscountCouponPanel;
  const type = button?.dataset.jsLoadDiscountCouponPanelType || 'coupon';

  if (!status) {
    return;
  }

  jsKit.setLoading(button, true);
  const response = await jsKit.requestUrl(`/basket/loadDiscountCouponPanel/${status}/${type}`, 'text');
  jsKit.setLoading(button, false);

  if (typeof response !== 'undefined') {
    setDiscountCouponPanelHtml(response);
    focusDiscountCouponInput();
  }
};

export const basketEvents = [
  ['jsAppendProductsToOrder', appendProductsToOrder],
  ['jsOmitRegistration', omitRegistration],
  ['jsBasketClientLogin', basketClientLogin, 'submit'],
  ['jsBasketClientRegister', basketClientRegister, 'submit'],
  ['jsCheckDiscountCoupon', checkDiscountCoupon],
  ['jsCloseDiscountCouponPanel', closeDiscountCouponPanel],
  ['jsLoadDiscountCouponPanel', loadDiscountCouponPanel],
  ['jsRemoveProduct', removeProduct],
  ['jsChangeProductAmountClick', changeProductAmount],
  ['jsChangeProductAmountChange', changeProductAmount, 'change'],
  ['jsRemoveDiscountCoupon', removeDiscountCoupon],
  ['jsChangeProductOption', changeProductOption],
  ['jsSetDeliveryAddress', setDeliveryAddress, 'change'],
  ['jsSetInvoiceAddress', setInvoiceAddress, 'change'],
  ['jsTogglePaymentOperators', togglePaymentOperators],
  ['jsToggleInvoiceData', toggleInvoiceData, 'change'],
  ['jsToggleRemarks', toggleRemarks, 'change'],
  ['jsToggleDeliveryRemarks', toggleDeliveryRemarks, 'change'],
  ['jsLoadClientComment', loadClientComment],
  ['jsSaveClientComment', saveClientComment],
  ['jsLoadDeliveryComment', loadDeliveryComment],
  ['jsSaveDeliveryComment', saveDeliveryComment],
  ['jsSetContestAgreement', setContestAgreement, 'change'],
  ['jsChangeGratis', changeGratis],
  ['jsSetUnfoldPackages', setUnfoldPackages, 'change'],
  ['jsCreateOrder', createOrder],
  ['jsBasketPaymentAndDelivery', basketPaymentAndDelivery],
];

export const registerBasketEvents = () => {
  basketEvents.forEach(([dataItem, handler, eventName]) => {
    jsKit.attachEventByDataSet(dataItem, handler, eventName);
  });
};

export const initBasketDiscountCoupon = () => {
  focusDiscountCouponInput();
  initBasketProductOptionPopovers();
};
